var map = {
	"./cinema-11.png": 1200,
	"./cinema-12.png": 1201,
	"./cinema-13.png": 1202,
	"./cinema-14.png": 1203,
	"./cinema-15.png": 1204,
	"./cinema-16.png": 1205,
	"./cinema-17.png": 1206,
	"./cinema-18.png": 1207
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1199;


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new-img/png-img ^\.\/cinema\-1.*\.png$
// module id = 1199
// module chunks = 173